// src/pages/CobrancaPix.js

import React, { useState } from 'react';
import PagamentoPixModal from '../components/PagamentoPixModal';
import './AdminModals.css'; // Reutilizando estilos
import { httpsCallable } from 'firebase/functions'; // <-- NOVA IMPORTAÇÃO
import { functions } from '../firebase';

const CobrancaPix = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [testStatus, setTestStatus] = useState(''); // Estado para a mensagem do teste
    const handleConnectionTest = async () => {
        setTestStatus("Testando conexão, por favor aguarde...");
        console.log("Iniciando teste de conexão...");

        try {
            const testarConexao = httpsCallable(functions, 'testarConexaoSantander');
            const result = await testarConexao();
            
            console.log('✅ Resultado do Teste:', result.data);
            setTestStatus(`SUCESSO! Resposta do servidor: ${result.data.message}`);

        } catch (error) {
            console.error('❌ Erro no Teste:', error);
            setTestStatus(`FALHA! Resposta do servidor: ${error.message}`);
        }
    };
    // Estado para guardar os dados do formulário
    const [formData, setFormData] = useState({
        valor: 2.00,
        descricao: "Pagamento de Teste via Admin",
        nomeDevedor: "",
        cpfDevedor: ""
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleOpenModal = (e) => {
        e.preventDefault(); // Previne o envio do formulário
        if (!formData.nomeDevedor || !formData.cpfDevedor) {
            alert("Por favor, preencha o nome e o CPF/CNPJ do devedor.");
            return;
        }
        setIsModalOpen(true);
    };

    const handlePaymentSuccess = () => {
        alert("CALLBACK: Pagamento confirmado com sucesso! Você pode prosseguir com o fluxo.");
        // Limpa os campos após o sucesso
        setFormData(prev => ({ ...prev, nomeDevedor: "", cpfDevedor: "" }));
    };

    return (
        <div className="admin-list-container">
            <div className="admin-list-header">
                <h1>Cobrança PIX Manual</h1>
            </div>
            <div className="sidebar-section" style={{marginBottom: '30px', paddingBottom: '30px'}}>
                <h3>Teste de Conexão com a API</h3>
                <p>
                    Antes de gerar uma cobrança real, use este botão para validar se a comunicação
                    com o servidor do Santander (incluindo o certificado) está funcionando.
                    Abra o console do navegador (F12) para ver os detalhes.
                </p>
                <button 
                    className="action-button edit-button" // Reutilizando estilo de botão
                    onClick={handleConnectionTest}
                >
                    Testar Conexão Santander
                </button>
                {testStatus && <p style={{marginTop: '15px', fontWeight: 'bold'}}>{testStatus}</p>}
            </div>
            
            <p>Use esta ferramenta para gerar uma cobrança PIX para um cliente específico.</p>
            
            <form onSubmit={handleOpenModal} style={{ maxWidth: '500px' }}>
                <div className="form-group">
                    <label htmlFor="valor">Valor da Cobrança (R$)</label>
                    <input type="number" id="valor" name="valor" value={formData.valor} onChange={handleInputChange} required />
                </div>
                <div className="form-group">
                    <label htmlFor="descricao">Descrição da Cobrança</label>
                    <input type="text" id="descricao" name="descricao" value={formData.descricao} onChange={handleInputChange} required />
                </div>
                <div className="form-group">
                    <label htmlFor="nomeDevedor">Nome Completo do Devedor</label>
                    <input type="text" id="nomeDevedor" name="nomeDevedor" value={formData.nomeDevedor} onChange={handleInputChange} required />
                </div>
                <div className="form-group">
                    <label htmlFor="cpfDevedor">CPF ou CNPJ do Devedor</label>
                    <input type="text" id="cpfDevedor" name="cpfDevedor" value={formData.cpfDevedor} onChange={handleInputChange} required />
                </div>

                <button type="submit" className="create-button">
                    Gerar PIX
                </button>
            </form>
            
            {/* O modal agora recebe os dados do devedor via props */}
            <PagamentoPixModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                valor={formData.valor}
                descricaoServico={formData.descricao}
                dadosDevedor={{
                    nome: formData.nomeDevedor,
                    cpf: formData.cpfDevedor
                }}
                onPaymentSuccess={handlePaymentSuccess}
            />
        </div>
    );
};

export default CobrancaPix;